const state = {
    comInfo: JSON.parse(sessionStorage.getItem("comInfo")) || {},
    reportStepId: sessionStorage.getItem("declare_reportStepId") || [],
    declareStepStatus: sessionStorage.getItem("declare_declareStepStatus") || 1,
    nowStepStatus: sessionStorage.getItem("declare_nowStepStatus") || 1,
    childStepStatus: sessionStorage.getItem("declare_childStepStatus") || 1
};

const mutations = {
    SET_COM_INFO: (state, comInfo) => {
        state.comInfo = comInfo;
        sessionStorage.setItem("comInfo", JSON.stringify(comInfo));
    },
    SET_REPORT_STEP_ID: (state, reportStepId) => {
        state.reportStepId = reportStepId;
        sessionStorage.setItem("declare_reportStepId", reportStepId);
    },
    SET_DECLARE_STEP_STATUS: (state, declareStepStatus) => {
        state.declareStepStatus = declareStepStatus;
        sessionStorage.setItem("declare_declareStepStatus", declareStepStatus);
    },
    SET_NOW_STEP_STATUS: (state, nowStepStatus) => {
        state.nowStepStatus = nowStepStatus;
        console.log("🚀 ~ nowStepStatus:", nowStepStatus);
        sessionStorage.setItem("declare_nowStepStatus", nowStepStatus);
    },
    SET_CHILD_STEP_STATUS: (state, childStepStatus) => {
        state.childStepStatus = childStepStatus;
        sessionStorage.setItem("declare_childStepStatus", childStepStatus);
    }
};

const actions = {
    setComInfo({ commit }, comInfo) {
        commit("SET_COM_INFO", comInfo);
    },
    setReportStepId({ commit }, reportStepId) {
        commit("SET_REPORT_STEP_ID", reportStepId);
    },
    setDeclareStepStatus({ commit }, declareStepStatus) {
        commit("SET_DECLARE_STEP_STATUS", declareStepStatus);
    },
    setNowStepStatus({ commit }, nowStepStatus) {
        commit("SET_NOW_STEP_STATUS", nowStepStatus);
    },
    setChildStepStatus({ commit }, childStepStatus) {
        commit("SET_CHILD_STEP_STATUS", childStepStatus);
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
